export const SET_USERS = 'SET_USERS'
export const UPDATE_USER = 'UPDATE_USER'
export const ADD_USER = 'ADD_USER'